export { default } from './Landing';